
import "vux";
import {SaafHeader, SaafScroller} from "@/common/components/index";
import {mapState} from "vuex";
import {service} from "@/common/index";
import {fetch} from "@/page/index";
import { initDefaultResponsibilitySession } from "@/utils/responsibilityUtils";
import {Dialog} from "vant";
import md5 from 'vux/src/tools/md5/index.js'

import CryptoJS from "crypto-js"
import systemHook from "../../../config/systemHook";
import Base64 from "vux/src/tools/base64";

export default {
data() {
return {
viewHeight: service.getViewHeight(service.componentHeight().native),
page: service.pageServer.newPage(),
list: [],
userObj: {


userName: "",
pwd: "",
verificationCode: "",
lan: "CN",
domain: "http://127.0.0.1:8984",
},
checked: true,
verificationSrc: "",
urlParams: {},
showLoginForm: false, // 是否显示账号密码登录表单
loading: true, // 加载状态，微信验证过程中显示
showPassword: false,

};
},
components: {
SaafHeader,
SaafScroller,
Dialog,
},
computed: {
...mapState({
userInfo: (state) => state.user.userInfo,
menus: (state) => state.user.menus,
}),
},
created() {
console.log('[login] created() 开始执行');
console.log('[login] URL: ' + window.location.href);
console.log('[login] pathname: ' + window.location.pathname);

this.getUrlAllParam()
this.userObj.domain = window.location.origin || this.userObj.domain
const code = this.getUrlParam('code')
const href = window.location.href
const hasAction = href.indexOf('action') > -1 || !!this.$route.query.action
const isBindWxAction = href.indexOf('action=bindWx') > -1 || this.$route.query.action === 'bindWx'


const isFeishuEnv = this.isFeishuEnvironment()
console.log('[login] isFeishuEnv: ' + isFeishuEnv);
console.log('[login] UserAgent: ' + window.navigator.userAgent);

this.showBootAuthLoading()


if (isBindWxAction) {
console.log('[login] 是绑定微信的回调，显示登录表单');
sessionStorage.removeItem('wechatOAuthPending')
sessionStorage.removeItem('feishuOAuthPending')
this.finishBootAuthLoading()
this.loading = false
this.showLoginForm = true
} else if (isFeishuEnv) {

console.log('[login] 检测到飞书环境，调用handleFeishuLogin');
sessionStorage.removeItem('wechatOAuthPending')
this.handleFeishuLogin()
} else if (code) {

console.log('[login] 检测到微信code: ' + code);
localStorage.setItem('wechatLoginAttempted', 'true')
sessionStorage.removeItem('wechatOAuthPending')
this.loading = true
this.showLoginForm = false
} else if (!hasAction) {

console.log('[login] 微信环境，无code，发起微信授权');
sessionStorage.setItem('wechatOAuthPending', '1')
this.loading = true
this.showLoginForm = false
this.wechatAuthorize()
} else {
console.log('[login] 其他情况，显示登录表单');
this.finishBootAuthLoading()
this.loading = false
this.showLoginForm = true
}

localStorage.removeItem('routeParentParams')
},
mounted() {
console.log('[login] mounted() 开始执行');

const code = this.getUrlParam('code')
const href = window.location.href
const isBindWxAction = href.indexOf('action=bindWx') > -1 || this.$route.query.action === 'bindWx'


const isFeishuEnv = this.isFeishuEnvironment()


if (isBindWxAction) {
console.log('[login] mounted: 是绑定微信的回调');
this.finishBootAuthLoading()
this.loading = false
this.showLoginForm = true
return
}


if (isFeishuEnv) {
console.log('[login] mounted: 飞书环境，不重复处理');
return
}

if (code) {
console.log('[login] mounted: 有code，调用wxLogin');
this.loading = true
this.showLoginForm = false
this.wxLogin(code)
return
}

if (sessionStorage.getItem('wechatOAuthPending') === '1') {
console.log('[login] mounted: wechatOAuthPending=1，等待授权');
return
}

console.log('[login] mounted: 显示登录表单');
this.finishBootAuthLoading()
this.loading = false
this.showLoginForm = true
},
activated: function () {
console.log('[login] activated()');
this.findList();
},
methods: {
showBootAuthLoading() {
console.log('[login] showBootAuthLoading()');
const bootEl = document.getElementById('boot-auth-loading')
if (bootEl) bootEl.style.display = 'block'
},
finishBootAuthLoading() {
console.log('[login] finishBootAuthLoading()');
sessionStorage.removeItem('wechatOAuthPending')
const bootEl = document.getElementById('boot-auth-loading')
if (bootEl) bootEl.style.display = 'none'
},
clearOAuthQuery() {
console.log('[login] clearOAuthQuery()');
if (!this.$route.query.code) return
this.$router.replace({ path: '/srmLogin' })
},

autoLogin() {
console.log('[login] autoLogin()');
if (!!this.userInfo && !!!this.userInfo.userName) {
this.userObj.userName = this.userInfo.userName
this.userObj.pwd = CryptoJS.enc.Utf8.stringify(CryptoJS.enc.Base64.parse(this.userInfo.encryptPwd))
this.onSubmit({})
}
},
findList(p) {
if (p === 0) {
this.$refs.SaafScroller.scrollTo(0, 0, 0);
this.page = service.pageServer.newPage();
}
},
listLookupValues() {
console.log('[login] listLookupValues()');
fetch.baseLookupTypeService_findDic().then(res=>{
localStorage.setItem("lookupValues", JSON.stringify(res.data));
this.$store.commit('SET_DIC_CODES', res.data)
})
},
onSubmit() {
console.log('[login] onSubmit()');
if (!this.checked) {
Dialog.alert({ message: "请先阅读并同意《协议》" });
return;
}
fetch.login({
userName: this.userObj.userName,
pwd: md5("" + this.userObj.pwd + "lo0.1l@g9v#"),
verificationCode: this.userObj.verificationCode,
lan: this.userObj.lan,
domain: this.userObj.domain
}).then((res) => {
if (res.status === "S") {
this.initLogin(res)
}
});
},
requestVerifySrc() {
fetch.generateRandomValidate({
lan: this.userObj.lan,
}).then((res) => {
if (res.status === "S") {
if (res.status === "S") {
this.verificationSrc = res.data;
}
}
});
},
requestMenu(list) {
console.log('[login] requestMenu()');
let _path = false;
let _routePush = () => {
console.log('[login] requestMenu: 跳转到TabPage');
this.$router.push("/TabPage");
_path = true
}

if (!list || !list.length) {
this.$store.commit("CLEAR_MENU", {});
if (!_path) _routePush();
return;
}

const initResp = async () => {
const result = await initDefaultResponsibilitySession(
this.$store,
list,
this.$store.state.user.languageCode
);
if (!result.success) {
console.log('[login] init default responsibility failed', result.message);
}
if (!_path) _routePush();
};

initResp();
},
initLanguage(lanList) {
if (lanList && lanList.length != 0) {
this.$store.commit("SET_LANGUAGE", lanList[0].lookupCode);
}
},
onProtocol() {
Dialog.alert({
title: "协议",
message: `赛意SRM系统平台致力于构建公开、透明的合作环境...`,
});
},
getUrlParam(paramName) {
const readFromQuery = (queryString) => {
if (!queryString) return null
const regex = new RegExp('[?&]' + paramName + '=([^&]*)')
const match = queryString.match(regex)
return match ? decodeURIComponent(match[1]) : null
}
let value = readFromQuery(window.location.search)
if (value) {
console.log('[login] getUrlParam从search获取: ' + paramName + '=' + value);
return value
}
if (this.$route.query && this.$route.query[paramName]) {
console.log('[login] getUrlParam从route.query获取: ' + paramName + '=' + this.$route.query[paramName]);
return this.$route.query[paramName]
}
const hash = window.location.hash || ''
if (hash.indexOf('?') > -1) {
value = readFromQuery(hash.substring(hash.indexOf('?')))
if (value) {
console.log('[login] getUrlParam从hash获取: ' + paramName + '=' + value);
return value
}
}
return null
},
getUrlAllParam() {

let _params = window.location.search;
_params = _params.substring(1, _params.length);
let _paramsArr = _params.split('&');
for (let i = 0; i < _paramsArr.length; i++) {
let _paramsArrItem = _paramsArr[i].split('=');
this.urlParams[_paramsArrItem[0]] = _paramsArrItem[1];
}

if (!!this.urlParams.singleEndpoint) {
localStorage.setItem('singleEndpoint', JSON.stringify(this.urlParams))
}
},
/**微信公众号登录*/
wxLogin(code) {
console.log('[login] wxLogin() code: ' + code);
this.loading = true
this.showLoginForm = false
fetch.wechat_login({
lan: this.userObj.lan,
domain: this.userObj.domain,
code: code,
}).then((res) => {
console.log('[login] wxLogin返回: status=' + res.status);
if (res.data && (res.code === "S" || res.code === "200" || res.status === "200")) {
localStorage.removeItem("wechatLoginAttempted");
this.clearOAuthQuery()
this.initLogin(res)
} else {
localStorage.removeItem("redirect");
localStorage.removeItem("wechatLoginAttempted");
this.finishBootAuthLoading()
this.loading = false;
this.showLoginForm = true;
}
}).catch((err) => {
console.log('[login] wxLogin异常: ' + err.message);
localStorage.removeItem("redirect");
localStorage.removeItem("wechatLoginAttempted");
this.finishBootAuthLoading()
this.loading = false;
this.showLoginForm = true;
});
},
/**初始化登录后信息*/
initLogin(res) {
console.log('[login] initLogin()');
this.finishBootAuthLoading()
const userInfo = res.data;
const userJson = userInfo ? JSON.stringify(userInfo) : "";
localStorage.setItem("userInfo", userJson);
this.$store.commit("INIT_USER_INFO");
if (!!userInfo) {
this.requestMenu(userInfo.userRespList);
this.initLanguage(userInfo.languageList);
this.listLookupValues();
}
},
/**微信公众号Oauth2.0身份认证*/
wechatAuthorize() {
console.log('[login] wechatAuthorize()');
sessionStorage.setItem('wechatOAuthPending', '1')
this.showBootAuthLoading()
let _appId = systemHook.config.wechat.appId
let _wechatUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + _appId + "&redirect_uri="
_wechatUrl += encodeURIComponent(systemHook.config.wechat.redirectUri)
_wechatUrl += "&response_type=code&scope=snsapi_base&state=" + systemHook.config.wechat.state + "&connect_redirect=1#wechat_redirect"
console.log('[login] 微信授权URL: ' + _wechatUrl);
window.location.replace(_wechatUrl)
},
/**检测是否在飞书环境*/
isFeishuEnvironment() {
const ua = window.navigator.userAgent.toLowerCase()

const result = ua.indexOf('lark') > -1 || ua.indexOf('feishu') > -1
console.log('[login] isFeishuEnvironment检测: ua=' + ua + ', result=' + result);
return result
},
/**处理飞书免登录*/
handleFeishuLogin() {
console.log('[login] handleFeishuLogin() 开始执行');
this.loading = true
this.showLoginForm = false
this.showBootAuthLoading()


console.log('[login] handleFeishuLogin: 跳转到/feishuToken');
this.$router.replace('/feishuToken')
},
},
watch: {},
};



// WEBPACK FOOTER //
// ./src/page/srm/login/login.vue